'use strict'

// A sample component

const Menu = {
    init: function () {
        const crossIcon = document.querySelector('.c-header-crossIcon');
        const burgerIcon = document.querySelector('.c-menu_burger');
        const burgerIconContainer = document.querySelector('.c-menu_burger_containerImage');
        const menuItems = document.querySelectorAll('.menu-item');
        const menuBuger = document.querySelector('.c-menu_sticky_container-burger');
        const menuList = document.querySelector('.c-header-menu_top');
        const menuContainerItems = document.querySelector('#container_id_custom');
        const menuCandidate = document.querySelector('.c-header-button_candidate');

        Menu.bloc = document.querySelector('.c-header-container_menu_burger')

        if (burgerIcon) {
            burgerIcon.addEventListener('click', () => {
                Menu.bloc.style.display = 'block'
                crossIcon.classList.add('isOpen')
                menuBuger.classList.add('openedBurger')
            })
        }

        if (crossIcon) {
            crossIcon.addEventListener('click', () => {
                Menu.bloc.style.display = 'none'
                crossIcon.classList.remove('isOpen')
                menuBuger.classList.remove('openedBurger')
            })
        }

        menuItems.forEach(item => item.addEventListener("click", () => item.classList.toggle("open")));

        if (window.innerWidth >= 1023 && !menuList.contains(menuContainerItems) && !menuList.contains(menuCandidate)) {
            burgerIconContainer.classList.add('hide');
        }
    },
}


export default Menu;


// WEBPACK FOOTER //
// ./src/scripts/components/Menu.js